/* eslint-disable react/require-default-props */
import React, { lazy, Suspense } from 'react';
import { loadFederatedModule } from '../../../utils/loadFederatedModule';

const ExcelIntegrationModalLazy = lazy(
  async () => loadFederatedModule<typeof import('WF/ExcelModal')>('WF/ExcelModal'),
);

export const ExcelIntegrationModal = (
  props: React.ComponentProps<typeof ExcelIntegrationModalLazy>,
) => (
  <Suspense fallback={null}>
    <ExcelIntegrationModalLazy {...props} />
  </Suspense>
);
